import AnimationController from '../../../assets/js/controllers/animation';

import { multiAddEventListener, multiRemoveEventListener, querySelectorArray } from '../../../assets/js/helpers';

export default class GridMaterials {

	static selector = 'grid-materials';

	// class variables

	config = {
		animations: {
			out: {
				duration: 600
			}
		}
	};

	el = {};

	timeouts = {
		transitionOut: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			options: container.querySelectorAll(`.${this.constructor.selector}__option`),
			optionLinks: container.querySelectorAll(`.${this.constructor.selector}__option a`),
			materialGroups: container.querySelectorAll(`.${this.constructor.selector}__grid-item-group`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.optionLinks, 'click', this.#onOptionClick);
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.optionLinks, 'click', this.#onOptionClick);
	}

	// listener methods

	#onOptionClick = (e) => {
		e.preventDefault();

		const $target = e.currentTarget;
		const $li = $target.closest('li');
		const { materialType } = $li.dataset;

		this.changeGroupByMaterialType(materialType);
	}

	//

	changeGroupByMaterialType(materialType) {
		const selector = `[data-material-type=${materialType}]`;

		const $group = querySelectorArray(this.el.materialGroups, selector, true);
		const $activeGroup = querySelectorArray(this.el.materialGroups, '.is-active', true);

		if ($group !== $activeGroup) {

			this.el.container.classList.add('is-not-first');

			// outro old group

			const $lastActiveGroup = $activeGroup;

			$lastActiveGroup.classList.add('is-out');
			$lastActiveGroup.classList.remove('is-active', 'is-active-in');

			this.clearTransitionOutTimeout();
			this.timeouts.transitionOut = setTimeout(() => {
				$lastActiveGroup.classList.remove('is-out');
			}, this.config.animations.out.duration);

			// intro new group

			$group.classList.add('is-active');

			AnimationController.one({
				update: () => true,
				render: () => {
					$group.classList.add('is-active-in');
				}
			});

			// change active option

			const $option = querySelectorArray(this.el.options, selector, true);
			const $activeOption = querySelectorArray(this.el.options, '.is-active', true);

			$activeOption.classList.remove('is-active');
			$option.classList.add('is-active');
		}
	}

	clearTransitionOutTimeout() {
		if (this.timeouts.transitionOut) {
			clearTimeout(this.timeouts.transitionOut);
			this.timeouts.transitionOut = null;
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
